import { requirePermission } from '@/utils/auth'
import { createFileRoute } from '@tanstack/react-router'
import DiagnosticsPage from '@/components/Diagnostics/DiagnosticsPage'

export const Route = createFileRoute('/diagnostics/$source/$tab')({
  beforeLoad: () => requirePermission('vehicle_administration', 'write'),
  component: DiagnosticsPage,
})
